import { RTRWithdrawTransactionResponse } from 'vopay';
import { useEffect, FC, useState } from 'react';
import useFetchRTRWithdrawTransaction from '@/hooks/useApi/useFetchRTRWithdrawTransaction';
import VopayInstantWithdrawalInfo from './VopayInstantWithdrawalInfo';

type TransactionProps = {
  TransactionID: string;
  Notes: string;
  isParent?: boolean;
  jwt: string;
};

const VopayInstantWithdrawalContainer: FC<TransactionProps> = ({ TransactionID, Notes, isParent = false, jwt }) => {
  const [RTRWithdrawTransaction, getRTRWithdrawTransaction] = useFetchRTRWithdrawTransaction({ bearer: jwt });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<RTRWithdrawTransactionResponse>();

  useEffect(() => {
    getRTRWithdrawTransaction(TransactionID);
  }, [currentTransactionId]);

  useEffect(() => {
    if (RTRWithdrawTransaction) {
      setTransaction(RTRWithdrawTransaction);
    }
  }, [RTRWithdrawTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>
      {transaction && (
        <VopayInstantWithdrawalInfo transaction={transaction} Notes={Notes} isParent={isParent} jwt={jwt} />
      )}
    </div>
  );
};

export default VopayInstantWithdrawalContainer;
